/**
 * Leo Suite — identidade do produto (multi-clínica).
 * O nome de cada clínica vem da base de dados e é editável em Definições.
 */
export const LEO_SUITE = {
  suiteName: 'Leo Suite',
  productName: 'LeoClinic',
  leoSalesUrl: import.meta.env.VITE_LEOSALES_URL ?? '',
  /** Logo por defeito (LeoClinic · estilo Mr Leo Tech) — substituível em Definições */
  defaultAppLogoUrl: '/app-logo.svg',
} as const;
